import awards from "../../../de/shared/de.awards";
import branded_quotes from "../../../de/shared/de.branded-quotes";
import verticals from "./cn-education-secondary.verticals";
const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "cn-education-secondary-contact":
            return {
                page,
                helmet: {
                    meta_title: "业务 - 请求定价 | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.cn/training-centers/contact/",
                    lang: "zh"
                },
                ...pageFooter({ strings })
            };
        case "cn-education-secondary-home":
            return {
                page,
                helmet: {
                    meta_title: "K-12在线语言学习 | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone K-12混合式语言学习解决方案包含了教师教案指导，学生可随时使用，以帮助学习或提高英语或其他语种的语言技能。",
                    canonical_url: "https://www.rosettastone.cn/training-centers/",
                    lang: "zh"
                },
                ...pageFooter({ strings })
            };
        case "cn-education-secondary-solutions":
            return {
                page,
                helmet: {
                    meta_title: "K-12在线语言学习方案| Rosetta Stone",
                    meta_description:
                        "Rosetta Stone在线语言学习方案激励英语学习者和其它语种的学习者充满自信地开口说话。具体价格请咨询。",
                    canonical_url: "http://www.rosettastone.cn/training-centers/solutions/",
                    lang: "zh"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
